export default __webpack_public_path__ + "static/media/success-white.5a94bf32.svg";